const searchPopupToggleEls = document.querySelectorAll('[data-search-popup-toggle]')
const searchPopupEl = document.querySelector('[data-search-popup]')
const searchPopupCloseEl = document.querySelector('[data-search-popup-close]')

export function searchPopup() {
	if (!searchPopupToggleEls.length || !searchPopupEl) return

	searchPopupToggleEls.forEach(toggleEl => {
		toggleEl.addEventListener('click', () => {
			const isSearchPopupActive = searchPopupEl.classList.contains('active')
			if (isSearchPopupActive) {
				closeSearchPopup()
			} else {
				openSearchPopup()
			}
		})
	})

	if (searchPopupCloseEl) {
		searchPopupCloseEl.addEventListener('click', () => {
			closeSearchPopup()
		})
	}

	function openSearchPopup() {
		searchPopupEl.classList.add('active')
		document.addEventListener('click', closeWhenClickedOutside)
		document.addEventListener('keydown', closeWithEsc)
		searchPopupEl.addEventListener('transitionend', focusInput, { once: true })
	}

	function closeSearchPopup() {
		searchPopupEl.classList.remove('active')
		document.removeEventListener('click', closeWhenClickedOutside)
		document.removeEventListener('keydown', closeWithEsc)
	}

	function closeWhenClickedOutside(event) {
		const isToggleButton = Array.from(searchPopupToggleEls).some(toggleEl => 
			toggleEl === event.target || toggleEl.contains(event.target)
		)
		
		if (!searchPopupEl.contains(event.target) && !isToggleButton) {
			closeSearchPopup()
		}
	}

	function focusInput() {
		const searchInput = searchPopupEl.querySelector('input[type="search"]')
		if (searchInput) {
			searchInput.focus()
		}
	}

	function closeWithEsc(event) {
		if (event.key === 'Escape') {
			closeSearchPopup()
		}
	}
}